import React from 'react';
import moment from 'moment';

import { DatePickerField, ButtonGroup, SelectField, MCButton, View } from 'src/components/basic';
import { convertColumnsForSmallWidth, TableLibrary } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { lang, remCss, remFontCss, withRouter } from 'src/helpers';

import model from './model';
import LastSales from './LastSales';
import LANG_CONST from 'src/helpers/lang/const';

const statFields = [
  'appointment',
  'appointmentEarnings',
  'treatment',
  'ticket',
  'ticketEarnings',
  'earnings'
];

class DoctorStats extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    if (!model.initFlag) {
      model.refresh();
      model.loadTotal();
      model.initFlag = true;
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.initFlag = false;
  }

  onSearchChange = (key, value) => {
    if (value?.toString() === model.input(key)?.toString()) return;
    model.setStateSilent({ [key]: value, pageIndex: 0 });
    model.setListStateSilent({ items: [], total: 0 }, model.getCurrentId());
    model.refresh();
  };

  getTotalData = () => {
    let items = model.items();
    let total = {};
    statFields.forEach((field) => (total[field] = 0));
    items &&
      items.forEach((item) => {
        total.currency = item.currency;
        statFields.forEach((field) => {
          if (field == 'earnings') {
            let type = model.input('type') || 'all';
            let result =
              type == 'all'
                ? item.appointmentEarnings + item.ticketEarnings
                : item[type + 'Earnings'];
            if (result > 0) total.earnings += result;
          } else {
            if (item[field] > 0) total[field] += item[field];
          }
        });
      });
    return total;
  };

  render() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();
    let totalData = this.getTotalData();
    let totalEarningsApiState = model.getApiState('total');
    let totalEarningsLoading = totalEarningsApiState.loading;
    let { totalEarnings, lastMonthEarnings } = model.getState();
    let currency = model.getCurrency();
    const small = this.props.screenDetail?.innerWidth < 1180;

    const footerStyle = { paddingVertical: remCss(15) };
    const columns = [
      {
        label: small ? null : lang.t(LANG_CONST.date),
        sort: { sortKey: 'date' },
        // resize: true,
        // minWidth: '150',
        renderCell: (item) => {
          let period = model.input('period');
          if (period == 'week' || period == 'isoWeek') {
            let d1 = moment(item.day, 'YYYYMMDD').format('D MMM, YYYY');
            let d2 = moment(item.day, 'YYYYMMDD').add(6, 'days').format('D MMM, YYYY');
            return d1 + ' - ' + d2;
          } else if (period == 'month') {
            return moment(item.day, 'YYYYMMDD').format('MMMM, YYYY');
          } else {
            return moment(item.day, 'YYYYMMDD').format('D MMM, YYYY');
          }
        },
        footer: () => (
          <View style={footerStyle}>
            <span>Total:</span>
          </View>
        )
      },
      {
        label: 'Treatments',
        resize: true,
        // width: '10%',
        // minWidth: '80',
        renderCell: (item) => item.treatment,
        footer: () => (
          <View style={footerStyle}>
            <span>{totalData.treatment}</span>
          </View>
        )
      },
      {
        label: 'Appointments',
        resize: true,
        // width: '10%',
        // minWidth: '80',
        renderCell: (item) =>
          `${item.appointment} / ${item.appointmentEarnings.toFixed(2)} ${item.currency}`,
        footer: () => (
          <View style={footerStyle}>
            <span>
              {totalData.appointment} / {totalData.appointmentEarnings.toFixed(2)} $
              {totalData.currency}
            </span>
          </View>
        )
      },
      {
        label: 'Tickets',
        resize: true,
        // width: '10%',
        // minWidth: '80',
        renderCell: (item) => `${item.ticket} / ${item.ticketEarnings.toFixed(2)} ${item.currency}`,
        footer: () => (
          <View style={footerStyle}>
            <span>
              {totalData.ticket} / {totalData.ticketEarnings.toFixed(2)} ${totalData.currency}
            </span>
          </View>
        )
      },
      {
        label: 'Earnings',
        // minWidth: '150',
        // cellStyles: { textAlign: 'end' },
        renderCell: (item) => {
          let type = model.input('type') || 'all';
          let result =
            type == 'all'
              ? (item.appointmentEarnings + item.ticketEarnings).toFixed(2)
              : item[type + 'Earnings'].toFixed(2);
          return `${result} ${item.currency}`;
        },
        footer: () => (
          <View style={footerStyle}>
            <span>
              {totalData.earnings.toFixed(2)} {totalData.currency}
            </span>
          </View>
        )
      },
      {
        label: '',
        width: '100px',
        renderCell: (item) => {
          let label = (
            <MCButton
              outline
              small
              label={LANG_CONST.soon}
              radius
              style={{ width: remCss(75) }}
              quaternary
            />
          );
          if (item.earnings === 0)
            label = (
              <MCButton
                outline
                small
                label={LANG_CONST.zero}
                radius
                style={{ width: remCss(75) }}
              />
            );
          else if (item.paid === true)
            label = (
              <MCButton
                outline
                small
                label={LANG_CONST.paid}
                radius
                style={{ width: remCss(75) }}
              />
            );

          return <View style={{ alignItems: 'flex-end' }}>{label}</View>;
        }
      }
    ];

    return (
      <div
        className={'mc-container-content mc-doctor-stats'}
        style={this.props.statsOfClinic ? { padding: 0 } : {}}
      >
        <div className='mc-flex-20 mc-doctor-stats-inner'>
          <div className='mc-doctor-stats-left'>
            <div className={'mc-container-content__header'} style={{ gap: remCss(15) }}>
              <span>
                <ButtonGroup
                  medium
                  dark
                  primary
                  radius
                  flex
                  activeClass='white'
                  onChange={(val) => model.changePeriod(val)}
                  value={model.getState().period || 'day'}
                  options={[
                    { label: 'Day', value: 'day' },
                    { label: 'Week', value: 'isoWeek' },
                    { label: 'Month', value: 'month' }
                  ]}
                />
              </span>
              <SelectField
                style={{ marginLeft: remCss(20) }}
                width={remCss(150)}
                options={[
                  { value: 'all', label: 'All' },
                  { value: 'appointment', label: 'Appointments' },
                  { value: 'ticket', label: 'Tickets' }
                ]}
                template={5}
                isClearable={false}
                name={'type'}
                value={model.input('type') || 'all'}
                onChange={(name, val) => {
                  model.handleChange(name, val);
                  // model.refresh();
                }}
              />
              <span className={'mc-grow'} />
              <div className={'mc-flex'}>
                <DatePickerField
                  style={{ minWidth: remCss(200) }}
                  template={6}
                  icontype={2}
                  placeholder={'Start Date'}
                  placement={'bottom-center'}
                  name={'startDate'}
                  value={model.input('startDate')}
                  onChange={this.onSearchChange}
                  invalid={{}}
                />
                <DatePickerField
                  style={{ minWidth: remCss(200) }}
                  template={6}
                  icontype={2}
                  placeholder={'End Date'}
                  placement={'bottom-center'}
                  name={'endDate'}
                  value={model.input('endDate')}
                  onChange={this.onSearchChange}
                  invalid={{}}
                />
              </div>
            </div>

            <div className={'mc-container-content__body'}>
              <div className={'mc-container-content__body-content'}>
                <TableLibrary
                  loading={loading}
                  noResults={noResults}
                  searchQuery={searchQuery}
                  sortBy={model.state.sortBy}
                  selectedPage={model.state.pageIndex}
                  total={total}
                  limit={model.listLimit}
                  showPagination={false}
                  onSortChange={(sortBy) => {
                    model.handleChange('sortBy', sortBy);
                    model.setListState({ items: [] }, model.getCurrentId(), null, true);
                    model.loadMore();
                  }}
                  onSetPage={(v) => {
                    model.handleChange('pageIndex', v);
                    model.setListState({ items: [] }, model.getCurrentId(), null, true);
                    model.loadMore();
                  }}
                  data={items}
                  columns={small ? convertColumnsForSmallWidth(columns) : columns}
                  showHeader={!small}
                />
              </div>
            </div>
          </div>
          <div style={{ width: remCss(450) }}>
            <div className={'mc-container-content__body'} style={{ marginBottom: remCss(20) }}>
              <div className={'mc-container-content__body-content'}>
                <div style={{ opacity: 0.6 }}>Total</div>
                <div
                  data-testid='doctor-stats-total-earnings'
                  className='mc-text-center mc-doctor-stats-total-earnings'
                  style={{ fontSize: remFontCss(24) }}
                >
                  {!totalEarningsLoading ? `${totalEarnings.toFixed(2)} ${currency}` : ''}
                </div>
                <div className='mc-flex'>
                  <div className='mc-grow' style={{ opacity: 0.6 }}>
                    Previous 30 days
                  </div>
                  <div className='mc-doctor-stats-total-earnings-30'>
                    {!totalEarningsLoading ? `${lastMonthEarnings.toFixed(2)} ${currency}` : ''}
                  </div>
                </div>
              </div>
            </div>
            <div className={'mc-container-content__body'}>
              <div className={'mc-container-content__body-content'}>
                <LastSales />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DoctorStats);
